import React, { useCallback, useEffect } from 'react';
import FormRadio from '@app/component/form/input/radio/FormRadio';
import AlertScheduleType from '@app/model/alert/AlertScheduleType';
import FormInputDatePicker from '@app/component/form/input/text/FormInputTimePicker';
import WeekDay from '@app/model/alert/WeekDay';
import Utilities from '@util/Utilities';
import _pullAt from 'lodash/pullAt';
import AlertInput from '@app/model/alert/input/AlertInput';
import moment from 'moment';

const AlertScheduleField: React.FunctionComponent<{
    form: any,
    defaultValues: AlertInput
}> = ({form, defaultValues}) => {

    const scheduleTypeWatch = form.watch("schedule.type");
    const weekDaysWatch = form.watch("schedule.weekdays");

    const contains = useCallback((day: string) => {
        return !!weekDaysWatch && weekDaysWatch.includes(day)
    }, [weekDaysWatch])

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const values: string[] = weekDaysWatch.length === 1 && weekDaysWatch[0] === 'ALL' ? [] : weekDaysWatch;
        if (e.target.checked) {
            form.setValue("schedule.weekdays", [...values, e.target.value]);
        } else {
            const index = values.findIndex(v => v === e.target.value);
            if (index > -1) {
                _pullAt(values, [index]);
                if (values.length === 0) values.push("ALL");
                form.setValue("schedule.weekdays", values);
            }
        }
    }

    useEffect(() => {
        switch (scheduleTypeWatch) {
            case AlertScheduleType.TRIGGERED : {
                form.unregister("schedule.weekdays")
                form.unregister("schedule.time")
                break;
            }
            case AlertScheduleType.SCHEDULED : {
                form.setValue("schedule.weekdays", !!defaultValues.schedule.weekdays ? defaultValues.schedule.weekdays : ["ALL"])
                form.setValue("schedule.time", !!defaultValues.schedule.time ? defaultValues.schedule.time : moment().format("HH:mm"))
                break;
            }
        }
    }, [scheduleTypeWatch]);

    return <>
        <p className="text-sm font-semibold leading-6 text-gray-900 mb-2">Alert Frequency</p>
        <div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
            <div className="flex items-center">
                <FormRadio name="schedule.type" form={form} options={[
                    {label: 'Daily (as per plan)', value: AlertScheduleType.TRIGGERED},
                    {label: 'Schedule', value: AlertScheduleType.SCHEDULED}
                ]}/>
            </div>

        </div>
        {scheduleTypeWatch === AlertScheduleType.SCHEDULED && <div className="mt-5 space-y-5">
            <div className="block">
                <div className="flex justify-between"><label className="label">Set Hour</label></div>
                <div className="mt-0.5"><FormInputDatePicker name="schedule.time" isRequired form={form}/></div>
            </div>
            <div className="block">
                <div className="flex justify-between"><label className="label">Repeats on these days</label></div>
                <div className="flex-wrap space-y-4 sm:flex sm:items-center sm:space-x-4 sm:space-y-0">
                    <div className="flex items-center">
                        <input
                            id={`input_ALL`}
                            type="checkbox"
                            value={'ALL'}
                            onChange={() => form.setValue("schedule.weekdays", ["ALL"])}
                            checked={contains('ALL')}
                            className="input-checkbox"
                        />
                        <label htmlFor={`input_ALL`} className="ml-2 label">ALL</label>
                    </div>
                    <div className="hidden sm:flex items-center">
                        <span className="relative -mx-px h-6 w-px bg-gray-200"/>
                    </div>
                    {Object.keys(WeekDay).map(day => <div key={day}
                                                          className="flex items-center">
                        <div className="flex items-center">
                            <input
                                id={`input_${day}`}
                                type="checkbox"
                                value={day}
                                onChange={onChange}
                                checked={contains(day)}
                                className="input-checkbox"
                            />
                            <label htmlFor={`input_${day}`} className="ml-2 label">
                                {Utilities.snakeCaseToWords(day)}
                            </label>
                        </div>
                    </div>)}
                </div>
            </div>
        </div>}
    </>
}

export default AlertScheduleField;